<template lang="pug">
    .fullview
        vue-loading(type="spin" color="#1961ca" :size="{ width: '50px', height: '50px' }")
</template>

<script>
import { VueLoading } from 'vue-loading-template'

export default {
    name: 'loading',
    components: {
        VueLoading,
    }
}
</script>

<style lang="stylus">
.fullview
    width 100%
    height 100%
    background #fefefe
    position fixed
    top 0
    left 0
    center-align()
</style>